import { Component } from 'react';

class AddDomains extends Component {
    constructor() {
        super();
        this.accounts = window.accounts;
    }
    render() {
        return (
            <div className="settings-card settings-linked-accounts">
                <div className="settings-linked-accounts-header">
                    <div>
                        Select an Account
                        <div className="settings-linked-accounts-header-sub">
                            Please choose the Google Search Console account that the domain is
                            associated with
                        </div>
                    </div>
                </div>
                <div className="settings-linked-accounts-body">
                    {this.accounts.length ? (
                        this.accounts?.map((item, i) => (
                            <div key={i} className="settings-linked-accounts-item">
                                <div className="settings-linked-accounts-item-left">
                                    <img src={item.picture} />
                                    <div className="settings-linked-accounts-item-left-text-container">
                                        <div className="settings-linked-accounts-item-left-text">
                                            <div>
                                                {item.given_name} {item.family_name}
                                            </div>
                                            {item.client_email && (
                                                <div className="settings-linked-accounts-item-left-text-bottom">
                                                    {item.client_email}{' '}
                                                    <span className="email-address-container">
                                                        Added by{' '}
                                                        <span className="email-address">
                                                            {item.added_by_user_username}
                                                        </span>
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <a
                                    href={`/domains/link?account=${item.a_id}`}
                                    className="button button-filled button-primary px-16"
                                >
                                    Select
                                </a>
                            </div>
                        ))
                    ) : (
                        <div className="settings-linked-accounts-item-left-text">
                            You currently have no linked accounts.
                        </div>
                    )}
                    <div className="settings-linked-accounts-footer">
                        Or <a href="/customers/link">Link a new Google Search Console Account</a>
                    </div>
                </div>
            </div>
        );
    }
}

export default AddDomains;
